import { Schema } from "effect";
/**
 * Apple Retention Message Request Schema (RealtimeRequestBody)
 */ export class RetentionMessageRequest extends Schema.Class("RetentionMessageRequest")({
    bundleId: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"bundleId is required"
    })),
    environment: Schema.Literal("sandbox", "production"),
    productId: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"productId is required"
    })),
    subscriptionGroupIdentifier: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"subscriptionGroupIdentifier is required"
    })),
    originalTransactionId: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"originalTransactionId is required"
    })),
    locale: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"locale is required"
    })),
    countryCode: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"countryCode is required"
    })),
    // Optional fields
    appAccountToken: Schema.optional(Schema.String),
    customAttributes: Schema.optional(Schema.Record({
        key: Schema.String,
        value: Schema.String
    })),
    deviceIdentifierForVendor: Schema.optional(Schema.String),
    storefrontId: Schema.optional(Schema.String),
    cancellationReason: Schema.optional(Schema.Number.pipe(Schema.int(), Schema.between(1, 6)))
}) {
}
